export class CondicoesMoradia {
    id: number;
	descricao: string;
	usuarioAlteracao: number;
}